const FEATURES = [
  {
    icon: 'ri-4k-line',
    title: '高清画质 流畅播放',
    desc: '全平台支持1080P超清画质，智能码率自适应，无论何时何地都能享受影院级观影体验，追剧不卡顿。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '每日更新 同步热播',
    desc: '与各大平台同步更新最新剧集，大陆剧、韩剧、港剧第一时间上线，追剧快人一步，绝不错过精彩剧情。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '完全免费 无需会员',
    desc: '全部剧集免费观看，无需注册、无需付费，打开即看。无广告干扰，纯净观影环境，让追剧回归简单。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100/60 text-primary-600 text-xs font-medium mb-4">
              平台优势
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              为什么选择红桃影视
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              用心打造最好的追剧体验，让每一位剧迷都能享受纯粹的观影乐趣
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {FEATURES.map((feature, i) => (
              <div
                key={i}
                className="group p-6 md:p-8 bg-background-100 rounded-2xl border border-background-200/40 hover:border-primary-500/20 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-5">
                  <i className={`${feature.icon} text-xl md:text-2xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-3 font-heading">
                  {feature.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}